export default function FreeShippingIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <mask
        id="mask0_6970_37057"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="16"
      >
        <g clipPath="url(#clip0_6970_37057)">
          <path
            d="M11.3334 11L5.66671 11C5.45034 11 5.2398 10.9298 5.06671 10.8L1.33337 7.99999H11.3334M11.3334 11V7.99999M11.3334 11H13.152C14.4897 11 15.4503 9.71209 15.069 8.42986L14.7759 7.44444C14.2472 5.22222 14.2472 5 13.1897 5H11.3334M11.3334 5V7V7.99999M11.3334 5V7.99999"
            stroke="#666666"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M8.33337 3L5.33337 3"
            stroke="#666666"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle cx="2.33337" cy="3" r="1" fill="#666666" />
          <path
            d="M6.33337 12C6.33337 11.4477 5.88566 11 5.33337 11C4.78109 11 4.33337 11.4477 4.33337 12C4.33337 12.5523 4.78109 13 5.33337 13C5.88566 13 6.33337 12.5523 6.33337 12Z"
            stroke="#666666"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M13.3334 12C13.3334 11.4477 12.8857 11 12.3334 11C11.7811 11 11.3334 11.4477 11.3334 12C11.3334 12.5523 11.7811 13 12.3334 13C12.8857 13 13.3334 12.5523 13.3334 12Z"
            stroke="#666666"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </g>
      </mask>
      <g mask="url(#mask0_6970_37057)">
        <rect x="0.333374" width="16" height="16" fill="#183558" />
      </g>
      <defs>
        <clipPath id="clip0_6970_37057">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.333374)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
